'use client'

import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
} from 'react'

import { isContainsWhitelist } from '@/utils/toggle'

export const WhitelistFfContext = createContext<{
  whitelisted: string[]
  isWhitelistedFn: (flag: string) => boolean
}>({
  whitelisted: [],
  isWhitelistedFn: (_flag: string) => false,
})

export const WhitelistFfProvider = ({
  whitelistedFFs,
  children,
}: PropsWithChildren<{ whitelistedFFs: string[] }>) => {
  const isWhitelistedFn = useCallback(
    (flag: string) => {
      return isContainsWhitelist(whitelistedFFs, flag)
    },
    [whitelistedFFs]
  )

  return (
    <WhitelistFfContext.Provider
      value={{
        whitelisted: Array.isArray(whitelistedFFs) ? whitelistedFFs : [],
        isWhitelistedFn,
      }}
    >
      {children}
    </WhitelistFfContext.Provider>
  )
}

export const useWhitelistFf = () => {
  return useContext(WhitelistFfContext)
}
